Wee.fn.make('contact', {
	init: function() {
		Wee.validate.bindFields();

		$.history.bind({
			submit: 'ref:form'
		}, {
			begin: function() {
				return Wee.validate.isValid({
					scrollTop: 'ref:form'
				});
			}
		});
	},
	unload: function() {
		Wee.validate.destroy();
	}
});